import { put, call, takeLatest } from 'redux-saga/effects';
import { base_url, endpoints } from '../../../constants';
import { AxiosService } from '../../../services';
import { actionTypes } from '../../../types';
import { getCityByStateFailure, getCityByStateSuccess } from '../../actions/CreateCampaignActions/getCityByStateActions';

function* getCityByState({ payload, callback }) {
    try {
        const response = yield call(AxiosService, {
            method: 'get',
            base_url: base_url,
            endPoint: endpoints.getCityByState + `?stateId=${payload.stateId}`,
            payload: payload,
            isAuth: true,
        });
        console.log('====================================');
        console.log("GET_CITY_BY_STATE_SUCCESS status :", response.data.status);
        console.log("GET_CITY_BY_STATE_SUCCESS data :", response.data.response);
        console.log("GET_CITY_BY_STATE_SUCCESS message :", response.data.message);
        console.log('====================================');
        yield put(
            getCityByStateSuccess({
                status: response?.data?.status,
                response: response?.data?.response,
                message: response?.data?.message
            })
        );
        if (callback) {
            callback(
                response?.data?.status,
                response?.data?.response,
                response?.data?.message
            ); // Pass the response data to the callback
        }
    } catch (error) {
        console.log('====================================');
        console.log("GET_CITY_BY_STATE_FAILURE status :", error?.response?.status);
        console.log("GET_CITY_BY_STATE_FAILURE data:", error?.response?.data);
        console.log("GET_CITY_BY_STATE_FAILURE error :", error);
        console.log('====================================');
        yield put(getCityByStateFailure({
            status: error?.response?.data?.status,
            response: {},
            message: error?.response?.data?.message
        }));
    }
}

function* getCityByStateSaga() {
    yield takeLatest(actionTypes.GET_CITY_BY_STATE_REQUEST, getCityByState);
}

export default getCityByStateSaga;